import { CreatePartnerMemberRequestSchema, CreatePartnerMemberResponseSchema } from './create-partner-member.schema';
/**
 * Create Partner Member Endpoint Contract
 * Creates a Bliks user in the partner tenant and sends an activation invite.
 * Partner-admin only (enforced server-side).
 */ export const createPartnerMemberContract = {
    method: 'POST',
    path: '/api/v2/partner/team',
    description: 'Manually invites a person into the partner tenant by email',
    requestSchema: CreatePartnerMemberRequestSchema,
    responseSchema: CreatePartnerMemberResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid payload',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a partner-admin',
            409: 'Conflict - a user with this email already exists'
        }
    }
};

//# sourceMappingURL=create-partner-member.contract.js.map